import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import AddressForm from 'app/Components/Block/SaleJetBlock/Partials/AddressForm/AddressForm';
import {setDeliveryAddress}  from '../../ServiceAppointmentBlockSlice';
import {goToNextPageAsync} from '../../ServiceAppointmentAsyncthunk';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';

const AddressPage = (props) => {
  const [isSubmit, setIsSubmit] = useState(false);


    const selectedAddress = {
    cityName: props.subscriberAddress?.cityName ?? '',
    streetName: props.subscriberAddress?.streetName ?? '',
    home: props.subscriberAddress?.houseNumber ?? '',
    apartment: props.subscriberAddress?.apartment ?? '',
    zipCode: props.subscriberAddress?.zipCode ?? '',
    phoneNumber: props.phoneNumber ?? '',
  };

   async function setCustomerAddress(res) {
      const address = {
        cityName: res.selectedAddress.cityName,
        streetName: res.selectedAddress.streetName,
        home: res.selectedAddress.home,
        apartment: res.selectedAddress.apartment,
        zipCode: res.selectedAddress.zipCode,
        phoneNumber: res.selectedAddress.phoneNumber,
      };
      await props.setDeliveryAddress(address);

      if (Object.values(address).some((value) => value === null || value === undefined || value === '')) {
        // setShowErrorMsg(true);
      } else {
        // setShowErrorMsg(false);
        props.goToNextPageAsync();
      }
      setIsSubmit(false);
    }

    function handleOnContinue() {
      setIsSubmit(true);
    }

  return (
    <div className='address-page page-wrapper'>
      <div className='content'>
        <div className='title'> לאיזה כתובת לשלוח את ספק הכוח? </div>
        <div className='sub-title'> אפשר לשנות לכל כתובת שמתאימה לך </div>
        <AddressForm
          selectedAddress={selectedAddress}
          isSubmit={isSubmit}
          onSubmit={(res) => setCustomerAddress(res)}
          hideFloor={true}
          displayPhoneNumber={true}
        />
        {/* <div className='info-message'>בזמן ביקור השליח, חייב להיות בבית מבוגר מעל גיל 18</div> */}
      </div>
      <div className='button-wrapper'>
        <BtnSubmit isBusiness={false} text={'המשך'} onclick={handleOnContinue} formid='error-page' isDisplayArrows={false} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    subscriberAddress: state.serviceAppointmentSchedulerBlock.subscriber.address,
    phoneNumber: state.authentication.loginData?.userDetails?.contactNumber ?? '',
  };
};

const mapDispatchToProps = {
  setDeliveryAddress,
  goToNextPageAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressPage);
